import React from 'react';
import SearchBar2 from '../SearchBar/SearchBar2';
import DataTable2 from '../DataTable2/DataTable2';
import Popup from '../Popups/Popup';
import PopupWithUseClickOutside from '../Popups/PopupWithUseClickOutside';
import DataTableDisplayLengthToggle from '../DataTable2/DataTableDisplayLengthToggle';
import Pagination from '../DataTable2/Pagination';
import Cell from '../DataTable2/DataTableComponents/Cell';
import EditActionTriggerForm from '../ActionTriggers/EditActionTriggerForm';
import UserActionsMenuList from '../UserActionsMenuList/UserActionsMenuList';

export default class ActionTriggersIndexCard extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			meta: {},
			loading: false,
			initialized: false,
			userActionTriggerRequest: '',
			actionTriggerName: '',
			actionTriggerUrl: '',
			isActionComplete: false,
			isUserActionsMenuListVisible: false,
			isActionTriggerEditCardPopupVisible: false,
			isDeleteActionTriggerCardPopupVisible: false,
			isSuccessCardPopupVisible: false,
			isTimeoutCardPopupVisible: false,
			sortOrder: 'desc',
			sortColumn: 'updated_at',
			tempQuery: '',
			query: '',
			displayOptions: [
				10,
				25,
				50,
				100
			],
			currentPage: 1,
			pageLength: 25,
			pageNeighbours: 0
		};

		this.onInit = this.onInit.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onClearSearch = this.onClearSearch.bind(this);
		this.onChangeSortOrder = this.onChangeSortOrder.bind(this);
		this.onChangePageLength = this.onChangePageLength.bind(this);
		this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
		this.onShowUserActionsMenuList = this.onShowUserActionsMenuList.bind(this);
		this.onHideUserActionsMenuList = this.onHideUserActionsMenuList.bind(this);
		this.onShowActionTriggerEditCardPopup = this.onShowActionTriggerEditCardPopup.bind(
			this
		);
		this.onHideActionTriggerEditCardPopup = this.onHideActionTriggerEditCardPopup.bind(
			this
		);
		this.onShowDeleteActionTriggerCardPopup = this.onShowDeleteActionTriggerCardPopup.bind(
			this
		);
		this.onHideDeleteActionTriggerCardPopup = this.onHideDeleteActionTriggerCardPopup.bind(
			this
		);
		this.deleteActionTrigger = this.deleteActionTrigger.bind(this);
		this.onShowSuccessCardPopup = this.onShowSuccessCardPopup.bind(this);
		this.onHideSuccessCardPopup = this.onHideSuccessCardPopup.bind(this);
		this.onShowTimeoutCardPopup = this.onShowTimeoutCardPopup.bind(this);
		this.onHideTimeoutCardPopup = this.onHideTimeoutCardPopup.bind(this);
		this.onActionCompleted = this.onActionCompleted.bind(this);
	}

	componentDidMount(e) {}

	componentDidUpdate(prevProps, prevState) {}

	componentWillUnmount() {}

	render() {
		let actionTriggerParams = {
			query: this.state.query,
			page: this.state.currentPage,
			results_per_page: this.state.pageLength,
			sort_column: this.state.sortColumn,
			sort_order: this.state.sortOrder
		};

		const userActionMenuStyles = this.state.isUserActionsMenuListVisible
			? {
					backgroundColor: 'white',
					padding: '8px',
					border: '1px solid #CED4DA',
					borderRadius: '5px',
					position: 'absolute',
					top: '0px',
					left: '0px',
					zIndex: '99',
					cursor: 'pointer'
				}
			: {};

		return (
			<div className="ActionTriggersIndexCard card">
				<div className="card-body">
					<div className="row">
						<div className="col-6">
							<h1 className="card-title">
								<div className="UsersTitle">
									{I18n.t('admin.action_triggers')}{' '}
									<span>
										{this.state.meta.total_count ? (
											`(${this.state.meta.total_count})`
										) : (
											''
										)}
									</span>
								</div>
							</h1>
						</div>
						<div className="col-6">
							<button
								type="button"
								className="btn btn-primary new-action"
								onClick={() => {
									this.onShowActionTriggerEditCardPopup('add');
								}}
							>
								{I18n.t('admin.create_action_trigger')}
							</button>
						</div>
					</div>

					{this.state.meta.all_action_triggers_count <= 0 ? (
						<div
							className="jumbotron mt-4 mb-0 text-center"
							style={{ backgroundColor: '#fff' }}
						>
							<div>{'No action triggers exist'}</div>
						</div>
					) : null}

					<div
						style={
							this.state.meta.all_action_triggers_count <= 0 ? (
								{ display: 'none' }
							) : (
								{}
							)
						}
					>
						<div className="row filter-section">
							<div
								className={
									this.state.tempQuery.length > 0 ? (
										'col-10 col-md-10 col-lg-10'
									) : (
										'col-12 col-md-12 col-lg-12'
									)
								}
							>
								<SearchBar2
									placeholder={I18n.t('search_bar.placeholder')}
									name="tempQuery"
									value={this.state.tempQuery}
									onChange={this.onChange}
									onSubmit={this.onSearch}
								/>
							</div>
							<div
								className={
									this.state.tempQuery.length < 0 ? (
										''
									) : (
										'col-2 col-md-2 col-lg-2'
									)
								}
							>
								{this.state.tempQuery.length > 0 ? (
									<button
										type="button"
										style={{ marginLeft: '-15px' }}
										className="btn btn-primary"
										onClick={this.onClearSearch}
									>
										{I18n.t('admin.clear')}
									</button>
								) : (
									''
								)}
							</div>
						</div>
						<div className="row">
							<div
								className="jumbotron col-12 mt-4 mb-0 text-center"
								style={
									this.state.meta.total_count > 0 || !this.state.initialized ? (
										{ display: 'none' }
									) : (
										{ backgroundColor: '#fff', textAlign: 'center' }
									)
								}
							>
								<div>{'No records found.'}</div>
							</div>
							<div
								className="col-12"
								style={
									this.state.meta.total_count <= 0 ? { display: 'none' } : {}
								}
							>
								<DataTable2
									onInit={this.onInit}
									endpoint={this.buildEndpoint()}
									params={actionTriggerParams}
									sortOrder={this.state.sortOrder}
									sortColumn={this.state.sortColumn}
									columns={[
										{
											displayName: 'Name',
											apiName: 'name',
											colNum: 1,
											colWidth: 30
										},
										{
											displayName: 'Type',
											apiName: 'trigger_type',
											colNum: 2,
											colWidth: 40
										},
										{
											displayName: 'Last Updated',
											apiName: 'updated_at',
											colNum: 2,
											colWidth: 25
										},
										{
											displayName: '',
											apiName: 'edit',
											colNum: 3,
											colWidth: '',
											isSortable: false
										}
									]}
									rowRenderer={(d) => {
										return (
											<tr key={d.id}>
												<td>
													<Cell value={d.name} />
												</td>
												<td>
													<Cell value={`${d.trigger_type}: ${d.webhook_url}`} />
												</td>
												<td>
													<Cell value={d.updated_at} type="date" />
												</td>
												<td>
													<Cell
														value={
															<div
																onClick={(e) => {
																	e.stopPropagation();
																	e.preventDefault();
																	this.onSetUrlPath(d.action_trigger_url);
																	this.onShowUserActionsMenuList(d.id);
																}}
															>
																<i
																	className="fa fa-ellipsis-h"
																	aria-hidden="true"
																/>
																<div style={{ position: 'relative' }}>
																	<UserActionsMenuList
																		style={userActionMenuStyles}
																		data={[
																			{
																				id: 1,
																				type: 'edit',
																				displayName: 'Edit',
																				action: (e) => {
																					e.stopPropagation();
																					e.preventDefault();
																					this.onShowActionTriggerEditCardPopup(
																						'edit'
																					);
																				}
																			},
																			{
																				id: 2,
																				type: 'delete',
																				displayName: 'Delete',
																				action: (e) => {
																					e.stopPropagation();
																					e.preventDefault();
																					this.onShowDeleteActionTriggerCardPopup(
																						'delete',
																						d.name
																					);
																				}
																			}
																		]}
																		isMenuListVisible={
																			this.state
																				.isUserActionsMenuListVisible === d.id
																		}
																		hideMenuList={
																			this.onHideUserActionsMenuList
																		}
																		actionTriggerName={
																			this.state.actionTriggerName
																		}
																		actionTriggerUrl={
																			this.state.actionTriggerUrl
																		}
																		onShowActionTriggerEditCardPopup={
																			this.onShowActionTriggerEditCardPopup
																		}
																		onShowDeleteActionTriggerCardPopup={
																			this.onShowDeleteActionTriggerCardPopup
																		}
																	/>
																</div>
															</div>
														}
													/>
												</td>
											</tr>
										);
									}}
									onChange={this.onChange}
									onChangeSortOrder={this.onChangeSortOrder}
									isActionComplete={this.state.isActionComplete}
								/>
							</div>
						</div>
					</div>
					<div className="row table-footer">
						<div className="col-12 col-sm-6">
							<Pagination
								totalRecords={
									this.state.meta.total_count ? this.state.meta.total_count : 0
								}
								pageLength={this.state.pageLength}
								currentPage={this.state.currentPage}
								pageNeighbours={this.state.pageNeighbours}
								onChangeCurrentPage={this.onChangeCurrentPage}
							/>
						</div>
						<div className="col-12 col-sm-6">
							<DataTableDisplayLengthToggle
								totalRecords={
									this.state.meta.total_count ? this.state.meta.total_count : 0
								}
								displayOptions={this.state.displayOptions}
								pageLength={this.state.pageLength}
								onChangePageLength={this.onChangePageLength}
							/>
						</div>
						<PopupWithUseClickOutside
							isPopupVisible={this.state.isActionTriggerEditCardPopupVisible}
							onHidePopup={this.onHideActionTriggerEditCardPopup}
							style={{ maxWidth: '750px' }}
						>
							<Popup
								title={
									this.state.userActionTriggerRequest === 'add' ? (
										<h1 className="card-title">
											{I18n.t('admin.create_action_trigger_title')}
										</h1>
									) : this.state.userActionTriggerRequest === 'edit' ? (
										<h1 className="card-title">
											{I18n.t('admin.edit_action_trigger_title')}
										</h1>
									) : (
										'Invalid Action - Please Contact Support'
									)
								}
								onHidePopup={this.onHideActionTriggerEditCardPopup}
							>
								<EditActionTriggerForm
									create_action_trigger_endpoint={
										this.props.create_action_trigger_endpoint
									}
									get_action_trigger_endpoint={
										this.props.get_action_trigger_endpoint
									}
									update_action_trigger_endpoint={
										this.props.update_action_trigger_endpoint
									}
									thingBeingCreated={I18n.t('admin.action_trigger')}
									userActionTriggerRequest={this.state.userActionTriggerRequest}
									actionTriggerName={this.state.actionTriggerName}
									actionTriggerUrl={this.state.actionTriggerUrl}
									onHidePopup={this.onHideActionTriggerEditCardPopup}
									onShowSuccessCardPopup={this.onShowSuccessCardPopup}
									onShowTimeoutCardPopup={this.onShowTimeoutCardPopup}
									onActionCompleted={this.onActionCompleted}
								/>
							</Popup>
						</PopupWithUseClickOutside>
						<PopupWithUseClickOutside
							isPopupVisible={this.state.isSuccessCardPopupVisible}
							onHidePopup={this.onHideSuccessCardPopup}
						>
							<Popup
								title={
									<h1 className="card-title" style={{ color: 'green' }}>
										{I18n.t('success_card_title')}
									</h1>
								}
								body={
									this.state.userActionTriggerRequest === 'add' ? (
										I18n.t('admin.action_trigger.success_new_action_trigger')
									) : this.state.userActionTriggerRequest === 'edit' ? (
										I18n.t('admin.action_trigger.success_update_action_trigger')
									) : this.state.userActionTriggerRequest === 'delete' ? (
										I18n.t('admin.action_trigger.success_delete_action_trigger')
									) : null
								}
								onHidePopup={this.onHideSuccessCardPopup}
							/>
						</PopupWithUseClickOutside>
						<PopupWithUseClickOutside
							isPopupVisible={this.state.isTimeoutCardPopupVisible}
							onHidePopup={this.onHideTimeoutCardPopup}
						>
							<Popup
								title={
									<h1 className="card-title" style={{ color: 'red' }}>
										{I18n.t('timeout_card_title')}
									</h1>
								}
								body={I18n.t('timeout_card_body')}
								onHidePopup={this.onHideTimeoutCardPopup}
							/>
						</PopupWithUseClickOutside>
						<PopupWithUseClickOutside
							isPopupVisible={this.state.isDeleteActionTriggerCardPopupVisible}
							onHidePopup={this.onHideDeleteActionTriggerCardPopup}
						>
							<Popup
								title={
									<h1 className="card-title">
										{I18n.t('admin.action_trigger.delete_action_trigger_title')}
									</h1>
								}
								body={
									<div>
										{this.state.actionTriggerName ? (
											I18n.t(
												'admin.action_trigger.delete_action_trigger_body',
												{
													actionTriggerName: this.state.actionTriggerName
												}
											)
										) : (
											I18n.t('admin.action_trigger.delete_action_trigger_body')
										)}
										<div style={{ float: 'right' }} className="mt-4">
											<button
												className="btn btn-secondary mx-2"
												onClick={this.onHideDeleteActionTriggerCardPopup}
											>
												No, cancel
											</button>
											<button
												className="btn btn-primary"
												onClick={this.deleteActionTrigger}
											>
												Yes, delete
											</button>
										</div>
									</div>
								}
								onHidePopup={this.onHideDeleteActionTriggerCardPopup}
							/>
						</PopupWithUseClickOutside>
					</div>
				</div>
			</div>
		);
	}

	buildEndpoint() {
		return `${this.props.action_triggers_list_endpoint}`;
	}

	onChange(event) {
		const { name, value } = event.target;
		const { state } = this;
		state[name] = value;
		this.setState(state);
	}

	onSetUrlPath(urlPath) {
		this.setState({ actionTriggerUrl: urlPath });
	}

	onShowUserActionsMenuList = (id) => {
		// console.log('onShowUserActionsMenuList - id', id);
		this.setState({
			isUserActionsMenuListVisible: id
		});
	};

	onHideUserActionsMenuList = () => {
		this.setState({ isUserActionsMenuListVisible: false });
	};

	onShowActionTriggerEditCardPopup = (userActionTriggerRequest) => {
		if (userActionTriggerRequest === 'add') {
			// console.log('onShowActionTriggerEditCardPopup - Add');
			this.setState({
				isActionTriggerEditCardPopupVisible: true,
				userActionTriggerRequest: userActionTriggerRequest,
				actionTriggerUrl: null
			});
		} else if (userActionTriggerRequest === 'edit') {
			// console.log('onShowActionTriggerEditCardPopup - Edit');
			this.setState({
				isActionTriggerEditCardPopupVisible: true,
				isUserActionsMenuListVisible: false,
				userActionTriggerRequest: userActionTriggerRequest
			});
		}
	};

	onHideActionTriggerEditCardPopup = () => {
		this.setState({
			isActionTriggerEditCardPopupVisible: false
		});
	};

	onShowDeleteActionTriggerCardPopup(
		userActionTriggerRequest,
		actionTriggerName
	) {
		this.setState({
			userActionTriggerRequest: userActionTriggerRequest,
			actionTriggerName: actionTriggerName,
			isDeleteActionTriggerCardPopupVisible: true,
			isUserActionsMenuListVisible: false
		});
	}

	onHideDeleteActionTriggerCardPopup = () => {
		this.setState({
			isDeleteActionTriggerCardPopupVisible: false
		});
	};

	deleteActionTrigger() {
		$.ajax({
			type: 'DELETE',
			url: this.props.delete_action_trigger_endpoint,
			data: {
				action_trigger_url: this.state.actionTriggerUrl
			}
		}).done((data) => {
			// console.log('Done!', data);
			if (data.success == true) {
				// console.log('Action Trigger successfully deleted!', data);
				this.setState({
					loading: false
				});
				this.onHideDeleteActionTriggerCardPopup();
				this.onShowSuccessCardPopup('delete');
				this.onActionCompleted();
			} else if (data.status == 'session_expired') {
				// console.log('Session expired!');
				this.onHideDeleteActionTriggerCardPopup();
				this.onShowTimeoutCardPopup();
			} else {
				// console.log('Action Trigger delete failed!');
				this.setState({
					loading: false
				});
			}
		});
	}

	onShowSuccessCardPopup = () => {
		this.setState({
			isSuccessCardPopupVisible: true,
			sortOrder: 'desc',
			sortColumn: 'updated_at',
			tempQuery: '',
			query: '',
			currentPage: 1
		});
	};

	onHideSuccessCardPopup = () => {
		this.setState({ isSuccessCardPopupVisible: false });
	};

	onActionCompleted = () => {
		this.setState({ isActionComplete: true });
		this.setState({ isActionComplete: false }); // Reset state for next action
	};

	onShowTimeoutCardPopup = () => {
		this.setState({ isTimeoutCardPopupVisible: true });
	};

	onHideTimeoutCardPopup = () => {
		this.setState({ isTimeoutCardPopupVisible: false });
	};

	onSearch(event) {
		event.preventDefault();
		this.setState({ query: this.state.tempQuery });
	}

	onClearSearch(event) {
		event.preventDefault();
		// console.log('Clear Search Query', event.target.value);
		this.setState({ tempQuery: '', query: '', currentPage: 1 });
	}

	onChangeSortOrder(sortColumn, sortOrder) {
		if (sortOrder === '' || sortOrder === 'desc') {
			this.setState({
				sortColumn: sortColumn,
				sortOrder: 'asc',
				currentPage: 0
			});
		} else if (sortOrder === 'asc') {
			this.setState({
				sortColumn: sortColumn,
				sortOrder: 'desc',
				currentPage: 0
			});
		}
	}

	onChangeCurrentPage(currentPage) {
		this.setState({ currentPage: currentPage });
	}

	onChangePageLength(pageLength) {
		this.setState({ pageLength: pageLength, currentPage: 1 });
	}
	onInit() {
		this.setState({ initialized: true });
	}
}
